import { Component } from "../../../modules/Core/Component";
import templateDefault from "../../templates/default/widgets/navbar/main-appbar";
import Services from "../../Services/Services";

export default class Navbar extends Component {
  id = "navbar";
  group = "wishlist,order";

  // subMenu groups use: { title, items: [{ slug, title, url }] }
  mainMenu = [
    {
      slug: "womens",
      name: "WOMEN'S",
      url: "/women",
      subMenu: {
        category: {
          title: "Category",
          items: [
            { slug: "women-rings", title: "Rings", url: "/women/type/ring" },
            {
              slug: "women-bracelets",
              title: "Bracelets",
              url: "/women/type/bracelet",
            },
            {
              slug: "women-pendants",
              title: "Pendants",
              url: "/women/type/pendant",
            },
            {
              slug: "women-earrings",
              title: "Earrings",
              url: "/women/type/earrings",
            },
            {
              slug: "women-necklaces",
              title: "Necklaces",
              url: "/women/type/necklace",
            },
            {
              slug: "women-all",
              title: "Shop All jewelry",
              url: "/women/types/all",
            },
          ],
        },
        material: {
          title: "Material",
          items: [
            {
              slug: "women-gold",
              title: "Gold",
              url: "/women/metal/18kt-gold",
            },
            {
              slug: "women-mixed-metals",
              title: "Mixed Metals",
              url: "/women/metal/mixed-metals",
            },
            {
              slug: "women-sterling-silver",
              title: "Sterling Silver",
              url: "/women/metal/sterling-silver",
            },
            {
              slug: "women-leather",
              title: "Leather",
              url: "/women/metal/leather",
            },
          ],
        },
        featured: {
          title: "Featured",
          items: [
            {
              slug: "women-best-sellers",
              title: "Best Sellers",
              url: "/women/curation/best-sellers",
            },
            {
              slug: "women-new-arrivals",
              title: "New In",
              url: "/women/curation/new-arrivals",
            },
            {
              slug: "women-novelties",
              title: "Novelties",
              url: "/women/curation/novelties",
            },
            {
              slug: "women-sacred-symbols",
              title: "Sacred Symbols",
              url: "/women/curation/sacred-symbols",
            },
            {
              slug: "women-blue-statements",
              title: "Blue Statements",
              url: "/women/curation/blue-statements",
            },
            {
              slug: "birthstones",
              title: "evil eye Birth Stones",
              url: "/women/collection/birthstone",
            },
            {
              slug: "zodiacs",
              title: "Zodiacs",
              url: "/women/collection/zodiac",
            },
          ],
        },
        collection: {
          title: "Collection",
          items: [
            { slug: "view-all_", title: "View All", url: "/women/collections" },
          ],
        },
      },
    },
    {
      slug: "mens",
      name: "MEN'S",
      url: "/men",
      subMenu: {
        category: {
          title: "Category",
          items: [
            { slug: "men-rings", title: "Rings", url: "/men/type/ring" },
            {
              slug: "men-bracelets",
              title: "Bracelets",
              url: "/men/type/bracelet",
            },
            {
              slug: "men-pendants",
              title: "Pendants",
              url: "/men/type/pendant",
            },
            {
              slug: "men-necklaces",
              title: "Necklaces",
              url: "/men/type/necklace",
            },
            {
              slug: "men-cufflinks",
              title: "Cufflinks & Studs",
              url: "/men/type/cufflinks",
            },
            {
              slug: "men-earrings",
              title: "Earrings",
              url: "/men/type/earrings",
            },
            {
              slug: "men-all",
              title: "Shop All jewelry",
              url: "/men/types/all",
            },
          ],
        },
        material: {
          title: "Material",
          items: [
            { slug: "men-gold", title: "Gold", url: "/men/metal/18kt-gold" },
            {
              slug: "men-mixed-metals",
              title: "Mixed Metals",
              url: "/men/metal/mixed-metals",
            },
            {
              slug: "men-sterling-silver",
              title: "Sterling Silver",
              url: "/men/metal/sterling-silver",
            },
            {
              slug: "men-leather",
              title: "Leather & Beads",
              url: "/men/metal/leather",
            },
          ],
        },
        featured: {
          title: "Featured",
          items: [
            {
              slug: "men-best-sellers",
              title: "Best Sellers",
              url: "/men/curation/best-sellers",
            },
            {
              slug: "men-new-in",
              title: "New In",
              url: "/men/curation/new-arrivals",
            },
            {
              slug: "men-novelties",
              title: "Novelties",
              url: "/men/curation/novelties",
            },
            {
              slug: "men-sacred-symbols",
              title: "Sacred Symbols",
              url: "/men/curation/sacred-symbols",
            },
            {
              slug: "men-blue-statements",
              title: "Blue Statements",
              url: "/men/curation/blue-statements",
            },
            {
              slug: "animal-emblems",
              title: "Animal Emblems",
              url: "/men/curation/animal-emblems",
            },
            {
              slug: "zodiacs",
              title: "Zodiacs",
              url: "/women/collection/zodiac",
            },
          ],
        },
        collection: {
          title: "Collection",
          items: [
            { slug: "view-all_", title: "View All", url: "/men/collections" },
          ],
        },
      },
    },
    {
      slug: "gifts",
      name: "GIFTS",
      url: "/gifts",
      menu_template: "gifts",
      subMenu: {
        "shop-gifts": {
          title: "Shop Gifts",
          items: [
            {
              slug: "for-her",
              title: "For Her",
              url: "/women/gift/over-1",
            },
            {
              slug: "for-him",
              title: "For Him",
              url: "/men/gift/over-1",
            },
            { slug: "shop-all", title: "Shop All", url: "/gifts" },
          ],
        },
        "gifts-by-price-her": {
          title: "Gifts by Price Her",
          items: [
            {
              slug: "gifts-under-500",
              title: "Under $500",
              url: "/women/gift/under-500",
            },
            {
              slug: "gifts-under-1000",
              title: "Under $1000",
              url: "/women/gift/under-1000",
            },
            {
              slug: "gifts-under-2500",
              title: "Under $2500",
              url: "/women/gift/under-2500",
            },
            {
              slug: "luxe-gifts",
              title: "Luxe Gifts",
              url: "/women/gift/over-2500",
            },
          ],
        },
        "gifts-by-price-him": {
          title: "Gifts by Price Him",
          items: [
            {
              slug: "gifts-under-500",
              title: "Under $500",
              url: "/men/gift/under-500",
            },
            {
              slug: "gifts-under-1000",
              title: "Under $1000",
              url: "/men/gift/under-1000",
            },
            {
              slug: "gifts-under-2500",
              title: "Under $2500",
              url: "/men/gift/under-2500",
            },
            {
              slug: "luxe-gifts",
              title: "Luxe Gifts",
              url: "/men/gift/over-2500",
            },
          ],
        },
        services: {
          title: "Services",
          items: [
            { slug: "gift-cards", title: "Gift Cards", url: "/gift-cards" },
          ],
        },
      },
    },
    {
      slug: "collections",
      name: "COLLECTIONS",
      url: "/women/collections",
      menu_template: "collections",
      subMenu: {
        womens: {
          title: "Recent Women's",
          items: [
            {
              slug: "theodora",
              title: "THEODORA",
              url: "/women/collection/theodora",
            },
            { slug: "rhea", title: "RHEA", url: "/women/collection/rhea" },
            { slug: "neda", title: "NEDA", url: "/women/collection/neda" },
            {
              slug: "amazona",
              title: "AMAZONA",
              url: "/women/collection/amazona",
            },
            { slug: "kyma", title: "KYMA", url: "/women/collection/kyma" },
            {
              slug: "view-all-womens-collections",
              title: "View All Collections",
              url: "/women/collections",
            },
          ],
        },
        mens: {
          title: "Recent Men's",
          items: [
            { slug: "kavafi", title: "KAVAFI", url: "/men/collection/kavafi" },
            { slug: "kavos", title: "KAVOS", url: "/men/collection/kavos" },
            { slug: "hydra", title: "HYDRA", url: "/men/collection/hydra" },
            {
              slug: "alchemy",
              title: "ALCHEMY",
              url: "/men/collection/alchemy",
            },
            {
              slug: "laconia",
              title: "LACONIA",
              url: "/men/collection/laconia",
            },
            {
              slug: "view-all-mens-collections",
              title: "View All Collections",
              url: "/men/collections",
            },
          ],
        },
      },
    },
  ];

  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);

    this.getOrder();
    this.getMenu();
    this.checkWishlist();
    if (this.isAuthenticated()) {
      this.retrieveCoupons();
    }

    const errorOrderMessage = this.getHelpers("const").get(
      "error-order-message",
    );

    if (errorOrderMessage) {
      this.getHelpers("const").set("error-order-message", "");
      this.setData({ "error.order-message": errorOrderMessage });
    }
  }

  getMenu() {
    this.setData({ "default.mainMenu": this.mainMenu });
  }

  getOrder() {
    Services.get("order").then(([orderService]) => {
      orderService
        .fetchOrder()
        .then((orderService) => {
          const order = orderService.getData("order");
          this.setData({ "default.order": order });
        })
        .catch((orderService) => {});
    });
  }

  checkWishlist() {
    Services.get("wishlist").then(([wishlistService]) => {
      var wishlist = wishlistService.getWishlist();
      this.setData({ "default.wishlist": wishlist });
    });
  }

  retrieveCoupons() {
    Services.get("coupon").then(([couponService]) => {
      couponService
        .getCoupons()
        .then((couponService) => {
          const coupons = couponService.getData("coupons", []);

          this.setData({
            "default.coupons": coupons,
          });
        })
        .catch((err) => {
          console.log("regvfcdinj");
          console.log("error", err);
        });
    });
  }

  toggleMenuDrawer() {
    this.getComponents()
      .findById("menu-drawer")
      .forEach((drawer) => {
        drawer.toggle();
      });
  }

  toggleCartPopper(boolean) {
    this.getComponents().findById("cart-popper").first().setPopperOpen(boolean);
  }

  checkSearch(e) {
    e.preventDefault();
    const { search_term } = this.getData("default", null);
    const devHelper = this.getHelpers("env").getPublicUrl();
    if (search_term && search_term.length > 1) {
      window.location.href = devHelper + "/search/results?term=" + search_term;
    }
  }
}
